import { wishlistProductIdsKey } from '@/keys';
import useContext from './useContext';
import { setItemKey, subscribeKey, unsubscribeKey } from '@drapejs/core';
import { computed, inject, onBeforeUnmount, onMounted, Ref, ref } from 'vue';

export function getWishlist() {
  const wishlistProductIds = inject(wishlistProductIdsKey, ref([]));
  const { channel } = useContext();
  const subscribe = inject(subscribeKey);
  const unsubscribe = inject(unsubscribeKey);
  const setItem = inject(setItemKey);

  const wishlist = ref<any>([]);

  const initialCacheLoad = ref(true);

  const wishlistProducts = computed(() => {
    return wishlist.value.filter((r: any) => wishlistProductIds.value.find((e) => e == r.systemId));
  });

  onMounted(() => {
    subscribe?.(getWishlistCacheKey(channel.value?.locale), wishlistHandler, { immediate: true });
  });

  onBeforeUnmount(() => {
    unsubscribe?.(getWishlistCacheKey(channel.value?.locale), wishlistHandler);
  });

  function wishlistHandler(data: any): any {
    wishlist.value = data?.wishlistProducts?.products || [];
    if (
      !initialCacheLoad.value &&
      wishlist.value.length > 0 &&
      wishlistProductIds.value.find((f) => !wishlist.value.find((ff) => ff.systemId == f))
    ) {
      setItem?.(
        getWishListProductIdsCacheKey(channel.value.locale),
        wishlist.value.map((f) => f.systemId)
      );
    }

    initialCacheLoad.value = false;
  }

  return {
    wishlistProducts,
  };
}

export function getWishlistProductsCount() {
  const wishlistProductIds = inject(wishlistProductIdsKey, ref([]));
  const wishlistProductsCount = computed(() => {
    return wishlistProductIds.value?.length || 0;
  });

  return {
    wishlistProductsCount,
  };
}

export function getWishlistProductContext(product?: Ref<any>) {
  const wishlistProductIds = inject(wishlistProductIdsKey, ref([]));
  const setItem = inject(setItemKey);
  const { channel } = useContext();
  const isProductInWishlist = computed(() => {
    return wishlistProductIds.value?.find((r) => r === product?.value?.systemId) ? true : false;
  });

  async function toggleProductInWishlist() {
    if (product?.value?.systemId) {
      let newWishlist: string[] = [];
      if (isProductInWishlist.value) {
        newWishlist = wishlistProductIds.value.filter((r) => r != product?.value.systemId);
      } else {
        const capacity = channel.value?.website?.wishlistCapacity || 20;
        newWishlist = [...wishlistProductIds.value, product?.value.systemId].slice(-capacity);
      }

      await setItem?.(getWishListProductIdsCacheKey(channel.value.locale), newWishlist);
    }
  }

  return {
    toggleProductInWishlist,
    isProductInWishlist,
  };
}

export function getWishlistCacheKey(locale: string) {
  return `__wishlist_${locale}`;
}

export function getWishListProductIdsCacheKey(locale: string) {
  return `__wishlistProductIds_${locale}`;
}
